import { Button, Form, Typography } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { HeroImage } from '../FrontPage/FrontPage';
import { useLocation, useNavigate } from 'react-router-dom';
import { ContentContainer } from './components/ContentContainer';
import { useTranslation } from 'react-i18next';

export default function AlertsRemovalPage(): ReactElement {
    const loc = useLocation();
    const [status, setStatus] = useState("");
    const [id, setId] = useState("");
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation("emailRemoval");

    const confirmRemoval = () => {
        const realCall = async () => {
            try {
                setIsLoading(true);

                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/RemoveEmailFromTablePost?id=${id}`, {
                    body: JSON.stringify({}),
                    method: "POST"
                });

                if (res.ok) {
                    navigate("/halytykset/poisto?status=poistettu");
                }
                else {
                    setStatus("virhe");
                }
            } catch (error) {
                setStatus("virhe");
            } finally {
                setIsLoading(false);
            }
        };

        realCall();
    };

    useEffect(() => {
        const parsedParts = loc.search.substring(1).split("&");

        if (parsedParts.length > 0) {
            const statusPart = parsedParts[0].split("=");

            setStatus(statusPart[1]);

            if (parsedParts.length > 1) {
                const idPart = parsedParts[1].split("=");

                setId(idPart[1]);
            }
        }
    }, [loc.search]);
    return (
        <>
            <HeroImage>
                <ContentContainer>
                    <Typography.Title level={4}>{t("otsikko")}</Typography.Title>
                    <div>
                        {(status === "huoltokatko") && <>
                            <p><b>{t("huoltokatkoRivi1")}</b></p>
                            <br />
                            <p>
                                {t("huoltokatkoRivi2")}
                            </p></>}

                        {(status === "hyvaksyminen" || status === "virhe") && (id !== "" && id !== undefined && id !== null) && <>
                            {status === "virhe" && <p><b>{t("virheTuli")}</b></p>}
                            {status === "hyvaksyminen" && <p>{t("poistoKehotus")}</p>}
                            <Form onFinish={confirmRemoval} requiredMark={"optional"}>
                                <br />
                                <Button loading={isLoading} type="primary" htmlType="submit" value="Vahvista">{t("nappula")}</Button>
                            </Form>
                        </>}

                        {(status === "virhe") && (id === "" || id === undefined || id === null) && <>
                            <p><b>{t("virheIlmanId")}</b></p>
                        </>}

                        {(status === "poistettu") && <>
                            <p>{t("emailPoistettuViesti")}</p>
                            <br />
                            <p>
                                {t("eiEnääMailejaViesti")}
                            </p></>}
                        <br />
                    </div>
                </ContentContainer>
            </HeroImage>
        </>
    )
}
